import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  Renderer2,
  forwardRef,
  OnChanges,
  OnDestroy,
  inject
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Store } from '@ngrx/store';
import { MessageService } from 'primeng/api';
import { debounce } from 'lodash-es';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'vb-dec-number',
  templateUrl: './dec-number.component.html',
  styleUrls: ['./dec-number.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DecNumberComponent),
      multi: true
    }
  ],
  standalone: false  //NOSONAR
})
export class DecNumberComponent implements OnInit, OnChanges, OnDestroy {
  private renderer = inject(Renderer2);
  private elementRef = inject(ElementRef);
  private store = inject(Store);
  private ms = inject(MessageService);
  private cd = inject(ChangeDetectorRef);
  public utilService = inject(UtilService);

  @Input() element: any;
  @Input() disableField = false;
  @Input() formData: any = null;
  numVal: any;
  private modelValue: any;
  mode = 'numeric';
  private onChange: (m: any) => void;
  private onTouched: (m: any) => void;

  ngOnInit(): void {
    console.log(this.element);
    if (
      (this.formData.f_type === 'Currency' || this.formData.f_type === 'Double') &&
      (this.element.name === 'f_minVal' || this.element.name === 'f_maxVal')
    ) {
      this.mode = 'decimal';
    } else {
      this.mode = 'numeric';
    }
  }

  get model() {
    return this.modelValue;
  }

  writeValue(value: any): void {
    this.modelValue = value;
    this.numVal = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  set() {
    this.modelValue = this.numVal;
    this.onChange(this.modelValue);
  }

  setDisabledState(isDisabled: boolean) {
    this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
    // this.disabled = isDisabled;
  }

  debounceValChanges = debounce((value) => {
    this.numVal = value;
    this.set();
  }, 1000);
  valueChange(event) {
    this.debounceValChanges(event.value);
  }

  ngOnChanges(): void {
    if (this.formData?.f_sysF || (this.formData?.purpose && this.formData?.purpose === 'REFERENCE')) {
      this.disableField = true;
    }
  }

  ngOnDestroy(): void {
    //AutoUnsubscribe
    $(this.elementRef.nativeElement).remove();
  }
}
